import React from "react";
import PropTypes from "prop-types";
import { FormControl, MenuItem, Stack, TextField } from "@mui/material";
import useStyles from "./formStyles";

const SelectRenderer = ({
  options,
  name,
  value,
  onChange,
  disabled,
  error = "",
  label,
  multiple,
  colorPicker,
}) => {
  const styles = useStyles();

  return (
    <Stack direction="column" spacing={0.5} sx={{ width: "100%" }}>
      <span className={styles.label}>{label}</span>
      <FormControl fullWidth>
        <TextField
          select
          key={name}
          id="team-select"
          value={value}
          sx={{
            "& .MuiOutlinedInput-root": {
              borderRadius: "8px",
              "& fieldset": {
                borderColor: styles.input.borderColor,
              },
              "&:hover fieldset": {
                borderColor: styles.input.borderColor,
              },
              "&.Mui-focused fieldset": {
                borderColor: styles.input.borderColor,
              },
            },
          }}
          disabled={disabled}
          name={name}
          slotProps={{
            htmlInput: {
              style: { height: "40px", paddingBottom: "22px" },
            },
            input: {
              style: {
                height: "40px",
              },
            },
            select: { multiple },
            formHelperText: {
              className: styles.helperText,
            },
          }}
          error={!!error}
          helperText={error}
          onChange={onChange}
        >
          {options.map((item) => (
            <MenuItem key={item.value} value={item.value}>
              {colorPicker ? (
                <>
                  <div
                    className={styles.colorDiv}
                    style={{ backgroundColor: item.value }}
                  />
                  <span style={{ verticalAlign: "middle" }}>{item.text}</span>
                </>
              ) : (
                item.text
              )}
            </MenuItem>
          ))}
        </TextField>
      </FormControl>
    </Stack>
  );
};

SelectRenderer.propTypes = {};

export default SelectRenderer;
